import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import images from '../../helpers/images';
import Header from '../parts/Header';
import helpers from '../../helpers/helpers';
//import '../../assets/css/main.css';//css
 
function ThankYou (){
    const home_url = helpers.getHomeURL();

    return (
        <>
            <Header />
            <section className="cf-thank-you">
                <div className="container text-center p-3">
                    <img src={images.successIcon} />
                    <h1 className='fw-bold mb-5'>Thank you for your generosity!</h1>
                    <h3 className="text-larged mb-5">Your gift empowers children and communities to rise above poverty.</h3>
                    <Link className="btn btn-lg btn-primary btn-orange" to={home_url}>Go to Form Page</Link>
                </div>
            </section>
        </>
    )
}
 
export default ThankYou;